import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import useAppStore from "../../appStore";
import Autocomplete from "@mui/material/Autocomplete";

const schema = yup.object().shape({
    project_name: yup.string().required('Please enter project name'),
    // description: yup.string().required('Please enter description'),
    // image: yup.mixed().required('Please upload an image'),
});

export default function CreateSnapshot({ hideModal, posts }) {
    const { token } = useAppStore();
    const baseURL = process.env.REACT_APP_API_URL;
    const [image, setImage] = useState('');
    const [rowdata, setRowdata] = useState([]);
    const { register, handleSubmit, reset, setError, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            project_name: '',
            image: '',
        },
    });


    const onSubmitNew = async (data) => {
        try {
            let posturl = baseURL + "/seller-snapshot";
            if (image) {
                const response = await axios.post(posturl, {
                    project_name: data.project_name,
                    image: image,
                    name: rowdata.project_name,
                    slug: rowdata.slug,
                    post_id: rowdata.id,
                }, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-type": "Application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    toast.success('Snapshot created successfully!');
                    hideModal();
                }
            } else {
                toast.error('Please add snapshot!');
            }
        } catch (error) {
            console.error('Error creating snapshot:', error);
            toast.error('Failed to create snapshot. Please try again.');
        }
    };

    const handlePicChange = (event) => {
        console.log(event.target.files);
        let files = event.target.files;
        let reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (e) => {
            setImage(e.target.result);
        };
    };



    return (
        <>
            <Toaster />
            <Dialog
                open={true}
                onClose={hideModal}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <form onSubmit={handleSubmit(onSubmitNew)} className="w-full min-w-[600px] p-2 space-y-4">
                    <h2 className='mt-5 text-2xl text-blue-600 ml-4'>Add Snapshot</h2>
                    <DialogContent dividers={true}>
                        <DialogContentText id="scroll-dialog-description">
                            <div className="mt-4">
                                <label className="text-sm font-semibold mb-1">Project Name</label>
                                <div className="mt-2">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={posts}
                                        onChange={(e, v) => setRowdata(v)}
                                        getOptionLabel={(rows) => rows.project_name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Project name" size="small" name='project_name'  {...register("project_name")} />
                                        )}
                                    />
                                </div>

                                {errors?.project_name && <p className="text-red-500 text-xs mt-1">{errors.project_name?.message}</p>}
                            </div>
                            {/* <div className="mt-4">
                                <label className="text-sm font-semibold mb-1">Project Name</label>
                                <TextField
                                    className="w-full"
                                    variant="outlined"
                                    size="small"
                                    placeholder="Enter project name"
                                    {...register("project_name")}
                                />
                                {errors?.project_name && <p className="text-red-500 text-xs mt-1">{errors.project_name?.message}</p>}
                            </div> */}

                            <div className="mt-4">
                                <label className="text-sm font-semibold mb-1">Image</label>
                                <input
                                    className="w-full px-3 py-2 border rounded"
                                    type="file"
                                    accept="image/*"
                                    onChange={handlePicChange}
                                />
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={hideModal}>Cancel</Button>
                        <Button type="submit">Save</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
